module.exports = __webpack_public_path__ + "img/foto 5.853bcab2.jpg";